'use client';

import { ArticleCard, CardDate, Title } from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useHideDateStamp } from '@/app_lib/hooks/useHideDateStamp';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewRailSimple } from '@/app_lib/types/ArticlePreview';

export const ArticleCardRailSimple = ({
  article,
  className,
  useRelativeTime = false,
  hideDateStamp = false,
  articleDataCy,
  titleDataCy,
  dateDataCy,
}: {
  article: ArticlePreviewRailSimple;
  className?: string;
  useRelativeTime?: boolean;
  hideDateStamp?: boolean;
  articleDataCy?: string;
  titleDataCy?: string;
  dateDataCy?: string;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();
  const hideDateFromExperiment = useHideDateStamp();
  const hideDate = hideDateStamp || hideDateFromExperiment;

  return (
    // NOTE: Should this gap use a token?
    <ArticleCard
      className={className}
      dataCy={articleDataCy}
      variant='railSimple'
    >
      <Title
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: 1,
          clickTarget: 'headline',
          moduleType: 'rail_simple',
        })}
        dataCy={titleDataCy}
        title={article.title}
        url={article.url}
        variant='railSimple'
      />
      <CardDate
        dataCy={dateDataCy}
        dateGmt={article.dateGmt}
        hidden={hideDate}
        useRelativeTime={useRelativeTime}
        variant='railSimple'
      />
    </ArticleCard>
  );
};
